"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PriceOffComboSavingsVariantOne = exports.PriceOffComboSavingsStyle = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Label = _interopRequireDefault(require("@airasia/phoenix-components/components/Label"));

var _Price = _interopRequireDefault(require("@airasia/phoenix-components/components/Price"));

var _HotelCard = require("./HotelCard.proptypes");

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _Button = _interopRequireDefault(require("@airasia/phoenix-components/components/Button"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var PriceWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__PriceWrapper",
  componentId: "sc-1hc0pvu-0"
})(["height:", ";display:flex;flex-direction:column;align-items:flex-end;justify-content:flex-end;margin-left:auto;padding-right:", ";padding-bottom:", ";padding-top:", ";font-style:normal;font-weight:normal;font-size:", ";line-height:150%;"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? '100%' : '60%';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.small;
}, function (_ref3) {
  var theme = _ref3.theme,
      isMobile = _ref3.isMobile;
  return !isMobile ? theme.space.small : 0;
}, function (_ref4) {
  var isMobile = _ref4.isMobile,
      theme = _ref4.theme;
  return !isMobile && theme.space.standard;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSize.XSmall;
});

var PriceText = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__PriceText",
  componentId: "sc-1hc0pvu-1"
})(["font-style:normal;font-weight:normal;font-size:", ";line-height:150%;text-align:right;color:#75767a;mix-blend-mode:normal;padding-bottom:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSize.XSmall;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.space.tiny;
});

var StrikeThrough = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__StrikeThrough",
  componentId: "sc-1hc0pvu-2"
})(["font-style:normal;font-weight:normal;font-size:", ";line-height:", ";text-decoration-line:line-through;color:#75767a;mix-blend-mode:normal;"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontSize.XSmall;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.lineHeight.XXSmall;
});

var GuestInfo = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__GuestInfo",
  componentId: "sc-1hc0pvu-3"
})(["font-style:normal;font-weight:500;font-size:10px;line-height:", ";text-align:right;color:#212124;mix-blend-mode:normal;"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.lineHeight.XSmall;
});

var Includes = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__Includes",
  componentId: "sc-1hc0pvu-4"
})(["font-style:normal;font-weight:normal;font-size:10px;line-height:150%;text-align:right;color:#75767a;mix-blend-mode:normal;padding-bottom:", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.space.tiny;
});

var Total = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__Total",
  componentId: "sc-1hc0pvu-5"
})(["font-style:normal;font-weight:normal;font-size:12px;line-height:", ";display:flex;align-items:center;text-align:right;color:#4c4c50;mix-blend-mode:normal;"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.lineHeight.XSmall;
});

var BoldWrapper = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__BoldWrapper",
  componentId: "sc-1hc0pvu-6"
})(["padding-left:5px;font-weight:bold;"]);

var ComboSavingsBubblePrice = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__ComboSavingsBubblePrice",
  componentId: "sc-1hc0pvu-7"
})(["background-color:#067e41;margin-left:45%;margin-top:5px;display:flex;flex-direction:column;align-items:center;justify-content:center;border-top-left-radius:4px;border-top-right-radius:4px;border-bottom-left-radius:4px;min-width:60%;white-space:nowrap;padding:5px 10px 5px 10px;color:white;margin-bottom:10px;position:relative;"]);

var ComboSavingsTagBubbleRightArrow = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__ComboSavingsTagBubbleRightArrow",
  componentId: "sc-1hc0pvu-8"
})(["position:absolute;bottom:-5px;right:0px;width:0px;height:0px;background-color:transparent;border-style:solid;border-top-width:0px;border-right-width:15px;border-bottom-width:15px;border-left-width:10px;border-top-color:transparent;border-right-color:#067e41;border-bottom-color:transparent;border-left-color:transparent;"]);

var PriceOffComboSavingsStyle = _styledComponents.default.p.withConfig({
  displayName: "PriceInfo__PriceOffComboSavingsStyle",
  componentId: "sc-1hc0pvu-9"
})(["color:white;text-transform:capitalize;text-align:center;padding:0px;margin:2px;font-size:12px;line-height:18px;"]);

exports.PriceOffComboSavingsStyle = PriceOffComboSavingsStyle;

var PriceOffComboSavingsVariantOne = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__PriceOffComboSavingsVariantOne",
  componentId: "sc-1hc0pvu-10"
})(["text-align:center;font-weight:900;"]);

exports.PriceOffComboSavingsVariantOne = PriceOffComboSavingsVariantOne;

var SelectRoomButtonContainer = _styledComponents.default.div.withConfig({
  displayName: "PriceInfo__SelectRoomButtonContainer",
  componentId: "sc-1hc0pvu-11"
})(["margin-top:10px;"]);

var SnapSavingsComponent = function SnapSavingsComponent(_ref13) {
  var gaIdExperimentValue = _ref13.gaIdExperimentValue,
      isComboSavingsTagEnabled = _ref13.isComboSavingsTagEnabled,
      discountText = _ref13.discountText,
      priceCurrency = _ref13.priceCurrency,
      locale = _ref13.locale,
      savingsAmount = _ref13.savingsAmount;
  var fixedFontSizeForVariant2 = '10px';

  if (discountText) {
    if (isComboSavingsTagEnabled && savingsAmount) {
      var snapSavings = Math.abs(savingsAmount);

      if (gaIdExperimentValue === 1) {
        return /*#__PURE__*/_react.default.createElement(ComboSavingsBubblePrice, null, /*#__PURE__*/_react.default.createElement(PriceOffComboSavingsStyle, null, discountText), /*#__PURE__*/_react.default.createElement(_Price.default, {
          amount: snapSavings,
          currency: priceCurrency,
          allowLocaleFormat: true,
          locale: locale,
          priceTemplate: "TEMPLATE2",
          color: "white",
          noDecimalValues: true,
          defaultIDRLocale: false
        }), /*#__PURE__*/_react.default.createElement(ComboSavingsTagBubbleRightArrow, null));
      }

      return /*#__PURE__*/_react.default.createElement(_Label.default, {
        textLimit: 4,
        customProperties: {
          size: fixedFontSizeForVariant2
        },
        labelColor: "tertiaryLight",
        textColor: "tertiaryDark"
      }, /*#__PURE__*/_react.default.createElement(PriceOffComboSavingsVariantOne, null, discountText, ' ', /*#__PURE__*/_react.default.createElement(_Price.default, {
        amount: snapSavings,
        currency: priceCurrency,
        allowLocaleFormat: true,
        locale: locale,
        priceTemplate: "TEMPLATE3",
        color: "white",
        noDecimalValues: true,
        defaultIDRLocale: false,
        customProperties: {
          fontSize: fixedFontSizeForVariant2
        }
      })));
    }

    return /*#__PURE__*/_react.default.createElement(_Label.default, {
      labelColor: "tertiaryLight",
      textColor: "tertiaryDark"
    }, discountText);
  }

  return null;
};

SnapSavingsComponent.propTypes = _HotelCard.PriceInfoPropTypes;
SnapSavingsComponent.defaultProps = _HotelCard.PriceInfoDefaultProps;

var PriceInfo = function PriceInfo(_ref14) {
  var discountText = _ref14.discountText,
      strikeThrough = _ref14.strikeThrough,
      price = _ref14.price,
      priceText = _ref14.priceText,
      perGuestText = _ref14.perGuestText,
      snapPriceText = _ref14.snapPriceText,
      totalPrice = _ref14.totalPrice,
      isMobile = _ref14.isMobile,
      theme = _ref14.theme,
      locale = _ref14.locale,
      gaIdExperimentValue = _ref14.gaIdExperimentValue,
      isComboSavingsTagEnabled = _ref14.isComboSavingsTagEnabled,
      savingsAmount = _ref14.savingsAmount,
      selectRoomLabel = _ref14.selectRoomLabel,
      withSelectRoom = _ref14.withSelectRoom;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var _ref15 = strikeThrough || {},
      currency = _ref15.currency,
      value = _ref15.value;

  var priceCurrency = price.currency;
  var priceValue = price.value;
  var totalPriceCurrency = totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.currency;
  var totalPriceValue = totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.value;
  var totalPriceText = totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.text;

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(PriceWrapper, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(SnapSavingsComponent, {
      discountText: discountText,
      savingsAmount: savingsAmount,
      locale: locale,
      priceCurrency: priceCurrency,
      gaIdExperimentValue: gaIdExperimentValue,
      isComboSavingsTagEnabled: isComboSavingsTagEnabled
    }), currency && value && /*#__PURE__*/_react.default.createElement(StrikeThrough, null, "".concat(currency, " ").concat(value)), /*#__PURE__*/_react.default.createElement(_Price.default, {
      amount: priceValue,
      currency: priceCurrency,
      allowLocaleFormat: true,
      locale: locale,
      noDecimalValues: true,
      defaultIDRLocale: false,
      customProperties: {
        marginRight: '-8px'
      }
    }), priceText && /*#__PURE__*/_react.default.createElement(PriceText, null, priceText), perGuestText && /*#__PURE__*/_react.default.createElement(GuestInfo, null, perGuestText), snapPriceText && /*#__PURE__*/_react.default.createElement(Includes, null, snapPriceText), totalPrice && /*#__PURE__*/_react.default.createElement(Total, null, "".concat(totalPriceCurrency), /*#__PURE__*/_react.default.createElement(BoldWrapper, null, "".concat(totalPriceValue, " ").concat(totalPriceText))), withSelectRoom && /*#__PURE__*/_react.default.createElement(SelectRoomButtonContainer, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      paddingRight: "24px",
      paddingLeft: "24px",
      backgroundColor: "primary",
      color: "primaryLight"
    }, selectRoomLabel)));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

PriceInfo.propTypes = _HotelCard.PriceInfoPropTypes;
PriceInfo.defaultProps = _HotelCard.PriceInfoDefaultProps;
var _default = PriceInfo;
exports.default = _default;